import axios from './axios';

/**
 * Get all contract templates
 */
export const getTemplates = async (params = {}) => {
  const response = await axios.get('/contract-templates', { params });
  return response.data;
};

/**
 * Get template by ID
 */
export const getTemplateById = async (id) => {
  const response = await axios.get(`/contract-templates/${id}`);
  return response.data;
};

/**
 * Alias for getTemplateById
 */
export const getTemplate = getTemplateById;

/**
 * Create new template
 */
export const createTemplate = async (data) => {
  const response = await axios.post('/contract-templates', data);
  return response.data;
};

/**
 * Update template
 */
export const updateTemplate = async (id, data) => {
  const response = await axios.put(`/contract-templates/${id}`, data);
  return response.data;
};

/**
 * Delete template
 */
export const deleteTemplate = async (id) => {
  const response = await axios.delete(`/contract-templates/${id}`);
  return response.data;
};

/**
 * Set template as active
 */
export const setActiveTemplate = async (id) => {
  const response = await axios.put(`/contract-templates/${id}/activate`);
  return response.data;
};

/**
 * Duplicate template
 */
export const duplicateTemplate = async (id, data = {}) => {
  const response = await axios.post(`/contract-templates/${id}/duplicate`, data);
  return response.data;
};

/**
 * Update template HTML content
 */
export const updateTemplateHtml = async (id, html) => {
  const response = await axios.put(`/contract-templates/${id}/html`, { html });
  return response.data;
};

/**
 * Update template variables
 */
export const updateTemplateVariables = async (id, variables) => {
  const response = await axios.put(`/contract-templates/${id}/variables`, { variables });
  return response.data;
};

/**
 * Update signature zones
 */
export const updateSignatureZones = async (id, zones) => {
  const response = await axios.put(`/contract-templates/${id}/signature-zones`, { zones });
  return response.data;
};

/**
 * Toggle template active status
 */
export const toggleTemplateActive = async (id) => {
  const response = await axios.put(`/contract-templates/${id}/toggle-active`);
  return response.data;
};

/**
 * Deactivate template
 */
export const deactivateTemplate = async (id) => {
  const response = await axios.put(`/contract-templates/${id}/deactivate`);
  return response.data;
};

/**
 * Preview template with test data
 */
export const previewTemplate = async (id, variables) => {
  const response = await axios.post(`/contract-templates/${id}/preview`, { variables });
  return response.data;
};

/**
 * Get template usage statistics
 */
export const getTemplateStats = async (id) => {
  const response = await axios.get(`/contract-templates/${id}/stats`);
  return response.data;
};

/**
 * Get contracts created from template
 */
export const getTemplateContracts = async (id) => {
  const response = await axios.get(`/contract-templates/${id}/contracts`);
  return response.data;
};

/**
 * Get the active template
 */
export const getActiveTemplate = async () => {
  const response = await axios.get('/contract-templates/active');
  return response.data;
};

/**
 * Generate preview PDF from template HTML
 * Returns PDF blob for signature zone editor
 */
export const generatePreviewPdf = async (id) => {
  const response = await axios.get(`/contract-templates/${id}/preview-pdf`, {
    responseType: 'blob'
  });
  return response.data;
};